<template>
  <div class="flex column" style="width: 100vm" v-title data-title="关于认证">
    <div v-for="(data, index) in list" :key="index">
      <div class="flex column" style="height: 49px; margin: 0 16px" @click="$router.push({name:'QuestionDetail', params: {question: JSON.stringify(data)}})">
        <div class="flex main-space-between cross-center" style="height: 49px;">
          <span>{{index + 1}}.{{data.title}}</span>
          <img src="../assets/arrow_right.png" style="width: 7px; height: 13px">
        </div>
        <div style="background: #EEEEEEFF; height: 1px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutAuth",
    data () {
      return{
        list: [
          {
            title: '为什么要进行教师认证?',
            detailTexts: [{title: '教师认证，是根据国家相关部门要求，保障学生注册信息安全。认证成功后，即可使用阅伴教师端App的创建班级，发布任务组织学生共读闯关。'}]
          },
          {
            title: '我们如何保障教师信息安全？',
            detailTexts: [{title: '阅伴通过了教育部备案，同时采取互联网前沿技术保障老师的信息安全，绝不会向任何第三方泄露。'}]
          },
          {
            title: '如何认证教师？',
            detailTexts: [{title: '在阅伴教师端App首页，点击“教师认证”，上传教师资格证照片即可。教师认证一般需要1-3个工作日，如需加急审核请拨打阅伴客服电话（029-89875100）。'}]
          },
          {
            title: '教师认证失败，怎么办？',
            detailTexts: [{title: '在教师端App首页，再次点击“重新认证”，重新提交教师资格证书照片即可（注意检查教师资格证照片是否正确）。'}]
          },
          {
            title: '教师资格证书不在身边，怎么办？',
            detailTexts: [{title: '请拨打阅伴客服电话（029-89875100）线上认证。'}]
          },
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutAuth.vue